module.exports = __webpack_public_path__ + "img/personCard.6c6e1930.jpg";